import React, { Component } from 'react';
import { UncontrolledTooltip, Input, Button, Badge, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import CounterInput from '../../components/reusable/CounterInput';
import c from '../../constants/Colors';
import localStorageCustom from '../../utilitarios/localStorage';
import { data } from '../../constants/Constants';
import { ActualizarStockPorLimitesProductoCarritoPedido, RegistrarMaterialSustituto, BuscarCarritoPedido, EliminarProductosCarritoPedido, EliminarProductoCarritoPedido, ActualizarStockProductoCarritoPedido, ListarMaterialSustituto } from '../../store/sagas/carritoApi';
import { BuscarKit } from '../../store/sagas/pedidoApi';
import { getStatePage } from '../../utilitarios/util';
import { AuthContext } from "../../store/provider/AuthProvider";
// import Alert from 'sweetalert2'
import { AgregarProductoFavorito } from '../../store/sagas/favoritoApi';
import CardPrecios from '../reusable/CardPrecios';
import ModalReemplazo from '../reusable/modals/Reemplazar';
import ModalLimpiarCarrito from '../reusable/modals/ModalLimpiarCarrito';
import ModalConfirmarCarrito from '../reusable/modals/ModalConfirmarCarrito';

import ModalKit from '../reusable/modals/kit';
import Spinner from "../reusable/Loader";

const CardStock = ({ item, postAgregarProductoFavorito, postActualizarStock, eventEliminar, eventCounter, auth, kit }) => {
  return (
    <div className="card_product_horizontal card_carrito">
      <div className="cphTextLeft">
        <Badge color="success">{item.validaStokStr}</Badge>
        <div>
          <h6 className="paragraph-2 bold mb-1" style={{ color: c.verdeClaro, wordBreak: 'break-word' }}>{item.maktx}</h6>
          <span className="paragraph-3 mb-3 d-block" style={{ color: c.verdeClaro }}>SKU: {item.matnr}</span>
        </div>
        <span className="paragraph-3" style={{ color: c.naranja }}>Total: {item.precioSubTotal}</span>
      </div>
      <div className="cphTextCenter">
        {/* <span className="paragraph-3 pu">P.U.</span> */}
        {/* <CardPrecios data={item.precios} className="cphTextCenter" /> */}
        <div className="prices mt-4">
          {/* <span className="paragraph-3 d-block previousPrice">{item.precioPublico}</span> */}
          <span className="paragraph-3 d-block">{item.precioPVD}</span>
        </div>
        <button
          className='btn-actualizar'
          type="button"
          onClick={() => { postActualizarStock(auth.carritoProdctos, auth.setcarritoProdctos, item) }}
        >
          Actualizar
        </button>
        <div className="options">
          {item.flagKit ? (
            <button className='btn-icon' onClick={() => kit(item.matnr, item.maktx)}>
              <SvgAssets icon="icon-kit" fill={'#ED7F9A'} />
            </button>) : (
            <button className='btn-icon'
              type="button"
              onClick={() => postAgregarProductoFavorito({
                codigo: item.matnr, descripcion: item.maktx,
                moneda: item.waers, pantalla: data.Pantalla.Carrito.Producto
              }, item.favorito, item.indice)}
            >
              <SvgAssets icon="icon-star" fill={item.favorito ? c.amarillo : c.celeste} />
            </button>
          )}
          <button className='btn-icon'
            type="button"
            onClick={() => { eventEliminar(auth.carritoProdctos, auth.setcarritoProdctos, item.idPk) }}
          >
            <SvgAssets icon="icon-trash" fill={c.celeste} />
          </button>
        </div>
      </div>
      <div className="cphCounterInput" style={{ backgroundColor: c.azulClaro, justifyContent: 'space-between' }}>
        <span className="paragraph-3" style={{ color: '#fff' }}>Cantidad</span>
        <CounterInput
          vertical
          background={c.azulClaro}
          color={"#fff"}
          borderColor={"#fff"}
          data={item}
          eventCounter={eventCounter}
        />
      </div>
    </div>
  )
}

const CardSinStock = ({ item, postAgregarProductoFavorito, eventReemplazo, postActualizarStock, eventEliminar, eventCounter, auth, kit }) => {
  return (
    <div className="card_product_horizontal card_carrito">
      <div className="cphTextLeft">
        <div className="reemplazar">
          <Badge color="danger">{item.validaStokStr}</Badge>
          {(item.sustituto) ?
            <button className='btn-icon' type="button"
              onClick={() => { eventReemplazo(item) }}>
              <SvgAssets icon="icon-foco" />
            </button>
            : null}
        </div>
        {(item.mensajeLlegada) ?
          <span className="fecha">“{item.mensajeLlegada}”</span>
          : null
        }
        <div>
          <h6 className="paragraph-2 bold mb-1">{item.maktx}</h6>
          <span className="paragraph-3 mb-3 d-block" style={{ color: c.grisMedio }}>SKU: {item.matnr}</span>
        </div>
        <span className="paragraph-3" style={{ color: c.grisMedio }}>Total: {item.precioSubTotal}</span>
      </div>
      <div className="cphTextCenter">
        {/* <span className="paragraph-3 pu" style={{ color: c.grisMedio }}>P.U.</span> */}
        <span className="paragraph-3 mt-4" style={{ color: c.grisMedio }}>{item.precioPVD}</span>
        <button
          className='btn-actualizar'
          type="button"
          onClick={() => { postActualizarStock(auth.carritoProdctos, auth.setcarritoProdctos, item) }}
        >
          Actualizar
        </button>
        <div className="options">
          {item.flagKit ? (
            <button className='btn-icon' onClick={() => kit(item.matnr, item.maktx)}>
              <SvgAssets icon="icon-kit" fill={'#ED7F9A'} />
            </button>
          ) : (
            <button
              className='btn-icon'
              type="button"
              onClick={() => postAgregarProductoFavorito({
                codigo: item.matnr, descripcion: item.maktx,
                moneda: item.waers, pantalla: data.Pantalla.Carrito.Producto
              }, item.favorito, item.indice)}
            >
              <SvgAssets icon="icon-star" fill={item.favorito ? c.amarillo : c.celeste} />
            </button>
          )}
          <button
            className='btn-icon'
            type="button"
            onClick={() => { eventEliminar(auth.carritoProdctos, auth.setcarritoProdctos, item.idPk) }}
          >
            <SvgAssets icon="icon-trash" fill={c.celeste} />
          </button>
        </div>
      </div>
      <div className="cphCounterInput" style={{ backgroundColor: c.azulClaro, justifyContent: 'space-between' }}>
        <span className="paragraph-3" style={{ color: '#fff' }}>Cantidad</span>
        <CounterInput
          vertical
          background={c.azulClaro}
          color={"#fff"}
          borderColor={"#fff"}
          data={item}
          eventCounter={eventCounter}
        />
      </div>
    </div>
  )
}

export class Carrito extends Component {
  static displayName = Carrito.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      show: false,
      option: '',
      isEmpty: false,
      dealer: {},
      linea: {},
      asociado: {},
      loading: true,
      localId: 0,
      pedidoId: 0,
      productos: [],
      mensajeSaldo: '',
      showModalLimite: false,
      alertas: [],
      datosTotal: {},
      mensajeTotal: "",
      dataReemplazo: {
        data: [],
        isVisible: false,
        producto: null
      },
      productoReem: {
        cantidad: 0
      },
      sinStock: false,
      showAlert: false,
      alertTitulo: "",
      alertMensaje: "",
      mostrarOfertas: true,
      procedencia: null,
      modalKit: false,
      kit: '',
      detalleKit: [],
    };
  }

  checkParams() {
    const { state } = this.props.location;
    if (state != undefined) {
      // let datosBuscador = state.datosBuscador;      
      if (state.datosBuscador) {
        this.setState({ localId: state.datosBuscador.localId });
      }
      if (state.procedencia) {
        this.setState({ procedencia: state.procedencia });
      }
    } else
      this.setState({ localId: 0, procedencia: null })
    // this.setState({ textBuscador: datosBuscador.text, textBuscadorOri: datosBuscador.text })
  }

  toggleModalAlertLimpiar = (close) => {
    this.setState({
      show: close,
      option: ''
    })
  }

  toggleOptionModalAlertLimpiar = (option) => {
    this.setState({
      option: option
    })
  }

  postActualizarStockPorLimites = async (setcarritoProdctos, productos) => {
    this.setState({ loading: true, showModalLimite: false })

    let productosLimite = productos.filter(m => m.mensajeSaldo != '').map(p => {
      return {
        ProductoId: p.idPk,
        Cantidad: p.saldo
      }
    })
    ActualizarStockPorLimitesProductoCarritoPedido(this.state.dealer,
      this.state.linea,
      this.state.asociado,
      this.state.localId,
      this.state.pedidoId,
      productosLimite)
      .then(result => {
        if (result.mo.type == "success") {
          let productosCantidad = result.dto.repuestos.filter(t => t.validaStok);
          let _sinStock = result.dto.repuestos.filter(t => !t.validaStok);
          setcarritoProdctos(result.dto.carritoProdctos);
          this.setState({
            loading: false,
            productos: result.dto.repuestos,
            mensajeSaldo: result.dto.mensajeSaldo,
            showModalLimite: result.dto.mensajeSaldo != '',
            isEmpty: result.dto.repuestos.length == 0,
            mensajeTotal: `(${productosCantidad.length} PRODUCTOS)`,
            datosTotal: {
              total: (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].total : 0,
              moneda: (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].sWaers : "",
            },
            sinStock: _sinStock.length > 0
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Carrito", error.message ?? null);
        });
      });
  }

  postEliminarProductoCarritoPedido = async (carritoProdctos, setcarritoProdctos, productoId) => {
    this.setState({ loading: true })
    EliminarProductoCarritoPedido(this.state.dealer, this.state.linea, this.state.asociado,
      this.state.localId, this.state.pedidoId, productoId)
      .then(result => {
        if (result.mo.type == "success") {
          setcarritoProdctos(result.dto.carritoProdctos);
          let productosCantidad = result.dto.repuestos.filter(t => t.validaStok);
          let _sinStock = result.dto.repuestos.filter(t => !t.validaStok);
          this.setState({
            loading: false,
            productos: result.dto.repuestos,
            mensajeSaldo: result.dto.mensajeSaldo,
            showModalLimite: result.dto.mensajeSaldo != '',
            isEmpty: result.dto.repuestos.length == 0,
            mensajeTotal: `(${productosCantidad.length} PRODUCTOS)`,
            datosTotal: {
              total: (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].total : 0,
              moneda: (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].sWaers : "",
            },
            sinStock: _sinStock.length > 0
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Carrito", error.message ?? null);
        });
      });
  }


  postLimpiarCarritoPedidoDemanda = async (carritoProdctos, setcarritoProdctos) => {
    var sinStockId = this.state.productos.filter(x => !x.validaStok).map(p => p.idPk);
    this.setState({ loading: true })
    EliminarProductosCarritoPedido(this.state.dealer, this.state.linea, this.state.asociado,
      this.state.localId, this.state.pedidoId, sinStockId)
      .then(result => {
        if (result.mo.type == "success") {
          setcarritoProdctos(result.dto.carritoProdctos);
          let _sinStock = result.dto.repuestos.filter(t => !t.validaStok);
          let productosCantidad = result.dto.repuestos.filter(t => t.validaStok);
          this.setState({
            show: false,
            option: '',
            loading: false,
            productos: result.dto.repuestos,
            isEmpty: result.dto.repuestos.length == 0,
            mensajeTotal: `(${productosCantidad.length} PRODUCTOS)`,
            mostrarOfertas: (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].mostrarOfertas : true,
            datosTotal: {
              total: (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].total : 0,
              moneda: (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].sWaers : "",
            },
            sinStock: _sinStock.length > 0
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Carrito", error.message ?? null);
        });
      });
  }

  postLimpiarCarritoPedido = async (carritoProdctos, setcarritoProdctos) => {
    this.setState({ loading: true })
    console.log("postLimpiarCarritoPedido");

    EliminarProductosCarritoPedido(this.state.dealer, this.state.linea, this.state.asociado,
      this.state.localId, this.state.pedidoId, [])
      .then(result => {
        if (result.mo.type == "success") {
          setcarritoProdctos(0);

          this.setState({
            show: false,
            option: '',
            loading: false,
            productos: [],
            isEmpty: true,
            mensajeTotal: `(0 PRODUCTOS)`,
            datosTotal: {
              total: 0,
              moneda: "",
            },
            sinStock: false
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Carrito", error.message ?? null);
        });
      });

  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  render() {
    const { mensajeSaldo, showModalLimite, sinStock, datosTotal, productoReem, isEmpty, productos, alertas, loading, asociado, mensajeTotal, dataReemplazo } = this.state;
    const auth = this.context;
    return (
      <div>
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1><SvgAssets icon="icon-cart" fill='#fff' />Carrito de compras</h1>
            <span className="desktop_parrafo2 d-block mt-2 light" style={{ color: c.celeste }}>Solo se pueden comprar repuestos con stock</span>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb mb-0">
          <Container>
            <ul>
              <li><Link to='/dashboard' className="active">Dashboard</Link></li>
              <li>Carrito de compras</li>
            </ul>
          </Container>
        </div>
        {isEmpty ?
          <div className="rs_container mobile">
            <h6 className="title-2 px-5">
              <a onClick={() => this.props.history.goBack()} className='back'><SvgAssets icon="icon-arrow-left" fill={c.azulClaro} /></a>
              {asociado.razonsSocial}
            </h6>
            <p className="paragraph-1 azul">Repuestos</p>
            <SvgAssets icon="curve-top" className='curve-bottom' fill="#1B52B2" />
          </div> : null
        }

        <Container className={`${(isEmpty ? "py-5" : "pt-5 pb-float")}`}>
          <div className="mb-4 mobile">
            <h6 className="title white mobile mb-0"><SvgAssets icon="icon-cart" fill="#fff" />Carrito de compras</h6>
            {!isEmpty ? <p className="paragraph-2 text-center light mobile" style={{ color: c.celeste }}>Solo se pueden comprar repuestos con stock</p> : null}
          </div>
          <div className="card">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#2861c2" />
            <div id="tooltip" className="tooltip-leyenda" style={{ width: 20, marginLeft: 'auto', position: 'relative', top: -12 }}>
              <SvgAssets icon="icon-info" fill={c.azulClaro} />
              <UncontrolledTooltip placement="left" target="tooltip" className="tooltip-leyenda">
                <span>PVD: Precio Venta Dealer</span>
                <span>PVP: Precio Venta Público</span>
                <hr />
                <span className="light">El total puede variar por cálculos en el PVD unitario</span>
              </UncontrolledTooltip>
            </div>
            {isEmpty ?
              <div>
                <div className="empty">
                  <SvgAssets icon="icon-cart" fill={c.celeste} />
                  <p className="paragraph-1 bold text-center" style={{ color: c.celeste }}>Tu carrito de compras está vacío</p>
                  <span className="total bold">TOTAL: S/ 0.00</span>
                </div>
                <div className="text-center mt-2 mobile">
                  <Link to="/generar-pedido" style={{ textDecoration: 'none' }}>
                    <button className='btn-block' style={{ backgroundColor: c.naranja }}>
                      ir al buscador<SvgAssets icon="icon-lupa" className='ml-2' fill="#fff" />
                    </button>
                  </Link>
                </div>
              </div>
              :
              <div>
                <div className="cards-wrap">
                  {productos.map((item, index) => {
                    return (
                      (item.validaStok) ?
                        <CardStock auth={auth} key={index} item={item} postAgregarProductoFavorito={this.postAgregarProductoFavorito} postActualizarStock={this.postActualizarStock} eventCounter={this.setCounter} eventEliminar={this.postEliminarProductoCarritoPedido} kit={this.toggleModalKit} /> :
                        <CardSinStock auth={auth} key={index} item={item} postAgregarProductoFavorito={this.postAgregarProductoFavorito} postActualizarStock={this.postActualizarStock} eventReemplazo={this.MostrarReemplazo} eventCounter={this.setCounter} eventEliminar={this.postEliminarProductoCarritoPedido} kit={this.toggleModalKit} />
                    )
                  })}
                </div>
                {/* {(productos.length > 0) ?
                  <p className={`total-price ${(isEmpty ? "azul" : "naranja")}`}>TOTAL  {mensajeTotal}: {productos[0].precioTotal}</p>
                  : null} */}
                {/* {isEmpty ?
                  <div>
                    {(productos.length > 0) ?
                    <p className="total-price azul">TOTAL  {mensajeTotal}: {productos[0].precioTotal}</p>: null}
                    <Link to="/generar-pedido" style={{ textDecoration: 'none' }}>
                      <button className='btn-block' style={{ backgroundColor: c.naranja }}>
                        ir al buscador<SvgAssets icon="icon-lupa" className='ml-2' fill="#fff" />
                      </button>
                    </Link>
                  </div>
                  : null
                } */}
              </div>
            }
            {(productos.filter(t => !t.validaStok).length == 0) ? null :
              <div className='text-left'>
                <Button
                  onClick={() => { this.postLimpiarCarritoPedidoDemanda(auth.carritoProdctos, auth.setcarritoProdctos) }}
                  // onClick={() => (productos.length == productos.filter(t => !t.validaStok).length || productos.length == productos.filter(t => t.validaStok).length) ?
                  //   this.postLimpiarCarritoPedido(auth.carritoProdctos, auth.setcarritoProdctos) :
                  //   this.toggleModalAlertLimpiar(true)
                  // }
                  color="link" className="btn_clear_list">
                  <SvgAssets icon='icon-trash-2' fill={c.azulClaro} />
                  Limpiar Carrito.
                </Button>
              </div>}
          </div>
          {isEmpty ?
            <Link to="/generar-pedido" className="desktop" style={{ textDecoration: 'none' }}>
              <button className='btn-block mt-5' style={{ backgroundColor: c.naranja }}>
                ir al buscador<SvgAssets icon="icon-lupa" className='ml-2' fill="#fff" />
              </button>
            </Link>
            : null}
        </Container>
        {(productos.length > 0) ?
          <div className="float_section">
            <SvgAssets icon="curve-top" className="curve" fill={c.azul} />
            <p className={`total-price ${(isEmpty ? "azul" : "naranja")}`}>
              TOTAL  {mensajeTotal}: <span className="bold" style={{ color: '#fff' }}>{productos[0].precioTotal.toLocaleString("en-US", { minimumFractionDigits: 2 })}</span>
            </p>
            <button className='btn-block' type="button"
              disabled={(datosTotal.total == 0 || showModalLimite)}
              onClick={() => this.IrOfertas()}
            >siguiente</button>
          </div>
          : null}
        <ModalReemplazo
          modal={dataReemplazo}
          dadComponent={this}
          reemplazo={productoReem}
          auth={auth}
        />

        <ModalLimpiarCarrito
          visible={this.state.show}
          option={this.state.option}
          toggle={this.toggleModalAlertLimpiar}
          toggleCheck={this.toggleOptionModalAlertLimpiar}
          toggleAceptar={this.postLimpiarCarritoPedidoDemanda}
          toggleLimpiar={this.postLimpiarCarritoPedido}
          carritoProdctos={auth.carritoProdctos}
          setcarritoProdctos={auth.setcarritoProdctos}
          sinStock={sinStock}
        />

        <ModalConfirmarCarrito
          visible={showModalLimite}
          auth={auth}
          data={productos}
          mensaje={mensajeSaldo}
          toggle={this.toggleModalAlertLimite}
          postActualizarStockPorLimites={this.postActualizarStockPorLimites}
        />


        <ModalKit dadComponent={this} detalleKit={this.state.detalleKit} />
      </div>
    );
  }
  toggleModalAlertLimite = () => {
    this.setState({ showModalLimite: false })
  }
  notificacion = async (alertTitulo = "", alertMensaje = "") => {
    this.setState({ alertTitulo, alertMensaje });
    this.toggleModalAlert();
  }
  toggleModalAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert,
    }));
  }
  toggleModalKit = (matnr, maktx) => {
    this.setState(prevState => ({
      modalKit: !prevState.modalKit,
    }));

    if (!this.state.modalKit) {
      this.setState(prevState => ({
        kit: maktx,
      }));
      this.postBuscarKit(this.state.dealer, this.state.linea, matnr)
    }
  }

  componentDidMount() {
    if (getStatePage(this.props)) {
      const auth = this.context;
      this.load(auth.carritoProdctos, auth.setcarritoProdctos, auth.setmostrarOfertas);
      this.checkParams()
    } else
      window.location.href = "/";
    // resizeInput();
  }

  IrDashboard = async () => {
    this.props.history.push('Dashboard');
  }
  load = (carritoProdctos, setcarritoProdctos, setmostrarOfertas) => {
    let data = localStorageCustom.prototype.getUsuario();
    this.setState({ loading: true, dealer: data.dealer, linea: data.linea, asociado: data.asociado }, () => {
      this.postBuscarCarritoPedido(carritoProdctos, setcarritoProdctos, setmostrarOfertas);
    })
  }
  CerrarReemplazo = () => {
    this.setState({
      dataReemplazo: {
        data: [],
        isVisible: false,
        producto: null
      },
      productoReem: { cantidad: 0 }
    })
  }
  ejectarReemplazo = (carritoProdctos, setcarritoProdctos) => {
    this.setState({
      loading: true
    })


    RegistrarMaterialSustituto(this.state.dealer,
      this.state.linea, this.state.asociado, this.state.localId, this.state.pedidoId,
      this.state.dataReemplazo.producto.idPk,
      this.state.productoReem)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            dataReemplazo: {
              data: [],
              isVisible: false,
              producto: null
            }
          })
          this.load(carritoProdctos, setcarritoProdctos);
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Carrito", error.message ?? null);
        });
      });
  }

  seleccionarReemplazo = async (value) => {
    this.setState({
      productoReem: { ...value, cantidad: 1, cantidadOriginal: 1 }
    })
  }

  setCounterReemplazo = (counter, tab, index) => {
    let _data = this.state.dataReemplazo.data



    let _reem = this.state.productoReem;
    let _isVisible = this.state.dataReemplazo.isVisible
    let _producto = this.state.dataReemplazo.producto
    if (counter == "") {
      _data[index].cantidad = 0;
      _data[index].precioTotal = 0;
    } else {
      _data[index].cantidad = counter;
      _data[index].precioTotal = counter * _data[index].pfin;
    }

    _reem.cantidad = counter;
    console.log("setCounterReemplazo==>", counter, tab, index, _data, _reem);
    this.setState({
      productoReem: _reem,
      dataReemplazo: {
        data: _data,
        isVisible: _isVisible,
        producto: _producto
      }
    })
  }

  MostrarReemplazo = async (prod) => {
    this.setState({
      loading: true
    })
    ListarMaterialSustituto(this.state.dealer, this.state.linea, this.state.asociado, prod.matnr, prod.cantidad)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            dataReemplazo: {
              data: result.dto.maerialSustituto,
              isVisible: true,
              producto: prod
            }
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Carrito", error.message ?? null);
        });
      });


  }

  IrOfertas = async () => {
    if (this.state.mostrarOfertas) {
      this.props.history.push({
        pathname: '/carrito/ofertas',
        state: {
          datosTotal: this.state.datosTotal,
          datosProductos: this.state.productos,
          localId: this.state.localId,
        }
      });
    } else {
      this.props.history.push({
        pathname: '/carrito/envio',
        state: {
          datosTotal: this.state.datosTotal,
          localId: this.state.localId,
          pedidoId: 0 //this.state.pedidoId
        }
      });
    }

  }
  postActualizarStock = async (carritoProdctos, setcarritoProdctos, prod) => {
    this.setState({ loading: true })
    ActualizarStockProductoCarritoPedido(this.state.dealer, this.state.linea, this.state.asociado,
      this.state.localId, this.state.pedidoId, prod.idPk, prod.cantidad)
      .then(result => {
        if (result.mo.type == "success") {
          let productosCantidad = result.dto.repuestos.filter(t => t.validaStok);
          let _sinStock = result.dto.repuestos.filter(t => !t.validaStok);
          setcarritoProdctos(result.dto.carritoProdctos);
          this.setState({
            loading: false,
            productos: result.dto.repuestos,
            mensajeSaldo: result.dto.mensajeSaldo,
            showModalLimite: result.dto.mensajeSaldo != '',
            isEmpty: result.dto.repuestos.length == 0,
            mensajeTotal: `(${productosCantidad.length} PRODUCTOS)`,
            datosTotal: {
              total: (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].total : 0,
              moneda: (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].sWaers : "",
            },
            sinStock: _sinStock.length > 0
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Carrito", error.message ?? null);
        });
      });
  }
  postAgregarProductoReemplazoFavorito = async (producto, AplicaFavorito, index) => {
    this.setState({ loading: true })
    AgregarProductoFavorito(this.state.dealer, producto, this.state.linea, !AplicaFavorito
    )
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false })

          let _dataReemplazo = this.state.dataReemplazo
          let _data = _dataReemplazo.data
          _data[index].favorito = !AplicaFavorito;
          this.setState({
            dataReemplazo: {
              data: _data,
              isVisible: _dataReemplazo.isVisible,
              producto: _dataReemplazo.producto
            }
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Reemplazo", error.message ?? null);
        });
      });
  }

  postAgregarProductoFavorito = async (producto, AplicaFavorito, index) => {
    this.setState({ loading: true })
    AgregarProductoFavorito(this.state.dealer, producto, this.state.linea, !AplicaFavorito
    )
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false })
          let _productos = this.state.productos
          _productos[index].favorito = !AplicaFavorito;

          this.setState({
            productos: _productos
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Carrito", error.message ?? null);
        });
      });
  }
  postBuscarCarritoPedido = async (carritoProdctos, setcarritoProdctos, setmostrarOfertas) => {
    BuscarCarritoPedido(this.state.dealer, this.state.linea, this.state.asociado, this.state.localId, this.state.pedidoId)
      .then(result => {
        if (result.mo.type == "success") {
          let productosCantidad = result.dto.repuestos.filter(t => t.validaStok);
          let _sinStock = result.dto.repuestos.filter(t => !t.validaStok);
          let _total = (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].total : 0;
          setcarritoProdctos(result.dto.carritoProdctos);

          let mostrarOfertas = (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].mostrarOfertas : true;
          this.setState({
            loading: false,
            mensajeSaldo: result.dto.mensajeSaldo,
            showModalLimite: result.dto.mensajeSaldo != '',
            productos: result.dto.repuestos,
            alertas: result.dto.alertas,
            isEmpty: result.dto.repuestos.length == 0,
            mensajeTotal: `(${productosCantidad.length} PRODUCTOS)`,
            mostrarOfertas,
            datosTotal: {
              total: _total,
              moneda: (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].sWaers : "",
            },
            sinStock: _sinStock.length > 0
          });
          setmostrarOfertas(mostrarOfertas);


        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Carrito", error.message ?? null);
        });
      });
  }

  postBuscarKit = (dealer, linea, Matnr) => {
    this.setState({ loading: true })
    BuscarKit(dealer, linea, Matnr)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            detalleKit: result.dto.detalleKit,
            loading: false,
          })

        } else {
          this.setState({
            detalleKit: [],
            loading: false,
          })
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          // notificacion("Buscador", error.message ?? null);
        });
      });
  }
  setCounter = (counter, item, index) => {

    let _productos = this.state.productos
    if (counter == "") {
      _productos[index].cantidad = 0;
    } else {
      _productos[index].cantidad = counter;
    }

    this.setState({
      productos: _productos
    })
  }
}
